import { IOption } from '@vtbhome/juicyfront/types';

export const normalizeSelectOptions = <T extends Object>(
    data?: T[],
    labelField = 'name',
    valueField = 'id'
): IOption[] =>
    data?.map((item) => ({
        label: item[labelField],
        value: String(item[valueField]),
    })) || [];

export const getSelectOptionFromObject = <T extends Object>(data: T): IOption[] =>
    Object.entries(data).map(([key, value]) => ({
        label: String(value),
        value: key,
    }));
